import {ProcessesPluginBase} from 'processes/graph-builder-processes/platform/ProcessesPluginBase';
import {
  DirectExecutionTaskSchemaNodeAdapter,
  EntryExecutionTaskSchemaNodeAdapter,
  FlowchartExecutionTaskSchemaNodeAdapter,
} from 'processes/graph-builder-processes/processes-plugin/TaskSchemaNodeAdapters';

import {ProcessFlowchartNodeAdapter} from '../flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';

export class DefaultProcessesPlugin extends ProcessesPluginBase {
  readonly pluginName: string = 'DefaultProcessesPlugin';

  readonly nodeAdapters: Array<ProcessFlowchartNodeAdapter> = [
    new DirectExecutionTaskSchemaNodeAdapter(),
    new EntryExecutionTaskSchemaNodeAdapter(),
    new FlowchartExecutionTaskSchemaNodeAdapter(),
  ];
}
